import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
} from '../../types';
import { overTimeSegmentedTableViewDataToUiComponentProps } from './dataToUiComponentProps';
import {
  OverTimeSegmentedTableViewActions,
  OverTimeSegmentedTableViewState,
  OverTimeSegmentedTableViewUiComponentProps,
} from './types';
import { OverTimeTableViewUiComponent } from './UiComponent';
import { useOverTimeLineChartStateManager } from './useStateManager';

export const overTimeTableViewSegmentedViewConfig: DataVizContainerViewConfigWithStateManager<
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
  OverTimeSegmentedTableViewUiComponentProps,
  OverTimeSegmentedTableViewState,
  OverTimeSegmentedTableViewActions
> = {
  hasStateManager: true,
  useStateManager: useOverTimeLineChartStateManager,
  dataToUiComponentProps: overTimeSegmentedTableViewDataToUiComponentProps,
  UiComponent: OverTimeTableViewUiComponent,
};
